import { useEffect, useState } from 'react'
import { getMarketSession, MarketSession } from '../_constants/market-calendar'

export default function useMarketSession(): MarketSession {
  const [session, setSession] = useState<MarketSession>(() => getMarketSession(new Date()))

  useEffect(() => {
    const tick = () => setSession(getMarketSession(new Date()))
    const id = window.setInterval(tick, 30 * 1000)
    const onVisibility = () => {
      if (document.visibilityState === 'visible') tick()
    }
    document.addEventListener('visibilitychange', onVisibility)
    return () => {
      window.clearInterval(id)
      document.removeEventListener('visibilitychange', onVisibility)
    }
  }, [])

  return session
}
